import React from "react";
import { ReactComponent as PhoneIcon } from "Global/Header/Icons/phoneCall.svg";

const NoCallsFound = () => (
  <div className="noCallsFound">
    <div className="noCallsFoundIcon">
      <PhoneIcon />
    </div>
    <h3 className="noCallsFoundTitle">We couldn't find any results.</h3>
    <p className="noCallsFoundDesc">Update your search, filters, or date range and try again.</p>
  </div>
);

export default NoCallsFound;
export { NoCallsFound };
